import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";
import React from "react";
import FinanceBadge from "./FinanceBadge";
import { currencyToDisplay, formatDate } from "../flex/utils";
import { Button } from "../ui/Button";
import MoreOptionsDropdown from "../flex/shipments/modals/MoreOptionsDropdown";
import { financeDropdownOptions, financeTypeForDate } from "constants/global";

const FinanceGroupCard = ({
    finance,
    currency,
    navigate,
    handleCancelFinance,
    handleMakePayModal,
    handleMakeRepaymentModal,
    deleteFinance,
}) => {
  const amountToShow = (finance) => {
    if (finance?.status === "disbursed" || finance?.status === "approved") {
      const unpaidLoan = finance?.loans?.find(loan => loan?.paymentStatus === 'UNPAID')
      return unpaidLoan?.amount || finance?.requestedAmount
    }
    return finance?.requestedAmount
  }
  const dateToShow = (finance) => {
    if (finance?.status === "draft" || finance?.status === "pending") {
      return finance?.createdAt
    } else if (finance?.status === "disbursed") {
      const unpaidLoan = finance?.loans?.find(loan => loan?.paymentStatus === 'UNPAID')
      return unpaidLoan?.dueDate
    } else {
      return finance?.updatedAt
    }
  }
    return (
        <div className="flex items-center justify-between gap-4 py-2 my-2">
            <div>
          <p className="font-[450] mb-1 text-gray-90 text-sm">
            {currencyToDisplay(currency, amountToShow(finance))}
            {" "}
                    <FinanceBadge badgeType={finance?.status} />
                </p>
                <p className="text-sm font-light text-gray-70">
                    {financeTypeForDate[finance?.status]}{" "}
            {formatDate(dateToShow(finance)
                    )}
                </p>
            </div>
            <div>
                <Button
                    size="sm"
                    variant="outline"
                    className="text-sm text-gray-90"
                    onClick={() => {
                        navigate("/finance/credit/" + finance?._id);
                    }}
                >
                    View
                </Button>
                {/* {finance?.loans?.paymentStatus !== "REPAID" &&  <MoreOptionsDropdown */}
                <MoreOptionsDropdown
                    options={financeDropdownOptions({
                        finance,
                        handleCancelFinance,
                        handleMakePayModal,
                        handleMakeRepaymentModal,
                        goTo: (path) => {
                            navigate(path, {
                                state: finance,
                            })},
                        deleteFinance,
                    })}
                />
            </div>
        </div>
    );
};

export default FinanceGroupCard;
